import { Engine, Loader, DisplayMode, Actor, CollisionGroupManager, Collider, CollisionGroup, Sound } from 'excalibur';
import { LevelOne } from './scenes/level-one/level-one';
import { onLoadComplete, Resources } from './resources';
import { Enemy } from './actors/enemies/enemy';
import { Tower } from './actors/towers/tower';

import title from './images/title.png';

import menuIntro from './images/menu_intro.wav';
import menuLoop from './images/menu_loop.wav';
import { TitleScene } from './scenes/title';
import { LoseScene } from './scenes/lose';

/**
 * Managed game class
 */
class Game extends Engine {
  public levelOne: LevelOne;

  constructor() {
    super({
      displayMode: DisplayMode.FitScreen,
      width: 1920,
      height: 1080 / 0.75,
      antialiasing: true
    });
  }

  public async start() {
    game.canvas.style.margin = 'auto';
    game.canvas.style.position = 'absolute';
    game.canvas.style.top = '0';
    game.canvas.style.left = '0';
    game.canvas.style.right = '0';
    game.canvas.style.bottom = '0';

    // Create new scene with a player
    this.levelOne = new LevelOne();
    const loader = new Loader(Object.values(Resources));

    loader.backgroundColor = "#000000";

    loader.startButtonFactory = () => {
      const button = document.createElement('button');

      button.style.position = 'fixed';
      button.style.zIndex = '100000';
      button.style.background = "url('" + title + "')";
      button.style.backgroundRepeat = 'no-repeat';
      button.style.backgroundSize = 'contain';
      button.style.backgroundPositionY = 'center';
      button.style.backgroundPositionX = 'center';
      button.style.width = '100vw';
      button.style.height = '100vh';
      button.style.border = 'none';
      button.style.left = '0';
      button.style.top = '0';
      button.style.objectFit = 'contain';

      return button;
    }

    super.start(loader);
  }
}

const game = new Game();
game.start().then(() => {
  onLoadComplete()
  game.add('title', new TitleScene());
  game.goToScene('title');
});